// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ManageSubCategoryList-containerWith-SA77u {
    width: 100%;
    max-width: 1260px !important;
    margin: 0 auto;
}

.ManageSubCategoryList-container-bfEGc {
    max-width: 100%;
}

/* Text - Start */

.ManageSubCategoryList-subText-pheI9 {
    color: var(--secondary-foreground);
    font-size: 14px;
}

/* Text - End */

/* Header */

.ManageSubCategoryList-navigationLink-AVMCr a {
    padding-right: 20px !important;
    padding-left: 20px !important;
    color: var(--primary-foreground) !important;
    font-size: 18px;
    border-bottom: 2px solid transparent;
}

.ManageSubCategoryList-navigationLink-AVMCr a:hover,
.ManageSubCategoryList-navigationLink-AVMCr a:focus,
.ManageSubCategoryList-navigationLink-AVMCr a:active {
    border-bottom: 2px solid var(--primary-foreground);
}

/* Header */

/* commonCss */

.ManageSubCategoryList-noPadding-UXv_h {
    padding: 0;
}

.ManageSubCategoryList-heading-O1EQw {
    padding: 30px 0px 24px 0px;
    font-weight: 700;
    font-size: 24px;
    color: var(--primary-foreground);
}

.ManageSubCategoryList-widthInner-I0M3m {
    margin: 0px auto 0px auto;
    border-radius: 4px;
    padding: 0px;
    margin: 0px 15px 30px;
}

.ManageSubCategoryList-noMargin-Wn10t {
    margin: 0;
}

.ManageSubCategoryList-formControlInputTable-RpWaf {
    border: none;
    width: 100px;
    height: auto;
}

.ManageSubCategoryList-backBtn-Hifbx {
    margin-left: 15px;
    display: inline-block;
}

.ManageSubCategoryList-backBtn-Hifbx:active,
.ManageSubCategoryList-backBtn-Hifbx:hover,
.ManageSubCategoryList-backBtn-Hifbx:focus {
    color: var(--primary-bg);
    text-decoration: none !important;
}

.ManageSubCategoryList-textAlignRight-V6Cnq {
    text-align: right;
}

.ManageSubCategoryList-displayInlineBlock-EKwFe {
    display: inline-block;
}

.ManageSubCategoryList-displayBlock-dZD2p {
    display: block;
}

.ManageSubCategoryList-countryCode-_tV9V {
    width: 15%;
    vertical-align: top;
}

.ManageSubCategoryList-vtrMiddle-ioFvf {
    vertical-align: middle;
}

/* commonCss */

.ManageSubCategoryList-editIcon-P8XE5 {
    width: 100%;
    width: 15px;
    vertical-align: middle;
    margin-right: 3px;
}

.ManageSubCategoryList-iconBtn-xuurk,
.ManageSubCategoryList-iconBtn-xuurk:hover,
.ManageSubCategoryList-iconBtn-xuurk:focus {
    padding: 0 !important;
    background: transparent !important;
    color: var(--danger-action-color) !important;
    border: 0 !important;
    white-space: nowrap;
    font-size: 16px !important;
    text-decoration: unset !important;
    cursor: pointer;
}

.ManageSubCategoryList-profileImg-HwvQt {
    width: 100%;
    height: auto;
    margin-bottom: 18px;
}

.ManageSubCategoryList-profileImgSection-YEhvr {
    width: 100%;
    margin: 0 auto;
    padding: 30px;
    border-radius: 12px;
    border: 1px solid var(--primary-border);
    background: var(--primary-input-bg);

}

.ManageSubCategoryList-profileImgWidth-T5omF {
    margin: 0;
    max-width: 100% !important;
}

.ManageSubCategoryList-searchInput-kMdxv {
    width: 100%;
    max-width: 320px;
}

.ManageSubCategoryList-backgroundImg-T5VUQ {
    padding-top: 42%;
    background-repeat: no-repeat;
    background-size: contain;
    margin-bottom: 18px;
    border-radius: 4px;
    background-color: transparent;
    background-position: center;
    margin-top: 6px;
    border: 1px dashed var(--primary-border);
    border-radius: 12px;
}

/*******************Export CSV section start ******************/

.ManageSubCategoryList-exportDisplay-feYyz {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    margin-bottom: 18px;
    gap: 18px;
    grid-gap: 18px;
}

.ManageSubCategoryList-exportTextSection-waAFd {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.ManageSubCategoryList-exportText-Wjckj {
    display: inline-block;
    padding-right: 5px;
}

.ManageSubCategoryList-exportTextContainer-FCQIH {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    color: var(--primary-link-foreground) !important;
    text-decoration: unset !important;
    border-bottom: 1px solid var(--primary-link-foreground);
}

.ManageSubCategoryList-vtrTextBottom-FOArq {
    vertical-align: text-bottom;
}

.ManageSubCategoryList-exportImg-QCQQD {
    width: 100%;
    max-width: 14px;
    height: 14px;
    -o-object-fit: contain;
       object-fit: contain;
}

/*******************Export CSV section End ******************/

.ManageSubCategoryList-noLink-JHWbe,
.ManageSubCategoryList-noLink-JHWbe:hover {
    color: var(--primary-link-foreground) !important;
    cursor: pointer;
}

.ManageSubCategoryList-singleCard-nyzag {
    width: 500px;
    margin: 0 auto;
}

.ManageSubCategoryList-defaultIcon-NWhJV {
    background-size: 50px;
}

.ManageSubCategoryList-assignProviderSearchInput-M_si_ {
    width: 100%;
    max-width: 324px;
}

.ManageSubCategoryList-searchGroupContainer-tMmkG {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
}

@media (max-width: 767px) {
    .ManageSubCategoryList-searchGroupContainer-tMmkG {
        width: 100%;
    }

}

@media (max-width: 1199px) and (min-width: 1024px) {
  .ManageSubCategoryList-widthInner-I0M3m {
    width: 100%;
    border-radius: 0;
    margin: 0 auto;
  }

  .ManageSubCategoryList-aboutGrid-M5Ne1 img {
    position: relative;
    top: -25px !important;
  }

  .ManageSubCategoryList-responsiveView-ePWd3 {
    width: 100% !important;
    max-width: 175px !important;
  }

  .ManageSubCategoryList-positionFive-ZNxxw {
    top: 28% !important;
  }

  .ManageSubCategoryList-positionTwo-EBbuN {
    top: 28% !important;
  }

  .ManageSubCategoryList-responsiveContentOne-Imm_s {
    top: -50px !important;
  }

  .ManageSubCategoryList-positionFour-GP2oN {
    top: -50px !important;
  }

  .ManageSubCategoryList-totalCss-sdUfL {
    width: 100% !important;
  }


}

@media (max-width: 1024px) {
  .ManageSubCategoryList-navbar-expand-lg-L7ip4 .ManageSubCategoryList-navbar-toggler-D0PS4 {
    display: block !important;
    position: absolute;
    top: 23px;
    right: 20px;
  }

  .ManageSubCategoryList-profileImgSection-YEhvr {
    padding: 18px;
  }
}

@media (max-width: 1023px) and (min-width: 768px) {

  .ManageSubCategoryList-navigationLink-AVMCr a {
    color: var(--primary-foreground) !important;
  }

  .ManageSubCategoryList-widthInner-I0M3m {
    width: 100%;
    border-radius: 0;
    margin: 0 auto;
  }

  .ManageSubCategoryList-responsiveContentOne-Imm_s {
    width: 300px !important;
    position: absolute !important;
    top: -42px !important;
    left: -5% !important;
  }

  .ManageSubCategoryList-positionTwo-EBbuN {
    top: 24% !important;
    left: -5% !important;
  }

  .ManageSubCategoryList-positionThree-d8_uC {
    top: 70% !important;
    left: -5% !important;
  }

  .ManageSubCategoryList-positionFour-GP2oN {
    top: -42px !important;
    right: -5% !important;
  }

  .ManageSubCategoryList-positionFive-ZNxxw {
    top: 20% !important;
    right: -5% !important;
  }

  .ManageSubCategoryList-positionSix-Zmcb_ {
    top: 70% !important;
    right: -5% !important;
  }

  .ManageSubCategoryList-responsiveView-ePWd3 {
    width: 100% !important;
    max-width: 115px !important;
  }

  .ManageSubCategoryList-aboutGrid-M5Ne1 img {
    top: -1px !important;
  }

  .ManageSubCategoryList-contentOne-fghvg h1 {
    font-size: 16px !important;
  }

  .ManageSubCategoryList-contentOne-fghvg p {
    font-size: 12px !important;
  }


  .ManageSubCategoryList-totalCss-sdUfL {
    width: 100% !important;
  }

  .ManageSubCategoryList-padding-u7XM5 {
    padding: 0px 0 0 60px !important;
  }

  .ManageSubCategoryList-singleCard-nyzag {
    width: 100% !important;
  }

  .ManageSubCategoryList-navigationLink-AVMCr a:hover,
  .ManageSubCategoryList-navigationLink-AVMCr a:focus,
  .ManageSubCategoryList-navigationLink-AVMCr a:active {
    border-bottom: 2px solid transparent;
  }
}

@media screen and (max-width: 823px) {
  .ManageSubCategoryList-navbar-collapse-JM8hf.ManageSubCategoryList-show-EW43C {
    right: 0% !important;
    top: 0 !important;
  }

  .ManageSubCategoryList-navbar-collapse-JM8hf {
    position: fixed !important;
    height: 100vh !important;
    width: 100% !important;
    background: #fff !important;
    right: -100% !important;
    -webkit-transition: 0.5s !important;
    transition: 0.5s !important;
  }
}

@media (max-width: 767px) {
  .ManageSubCategoryList-content-foQsv {
    float: none;
  }

  .ManageSubCategoryList-mr-auto-cRt7f.ManageSubCategoryList-navbar-nav-dnAe9 {
    padding-bottom: 80px !important;
  }

  .ManageSubCategoryList-navigationLink-AVMCr a {
    color: var(--primary-foreground) !important;
  }

  .ManageSubCategoryList-footer-ZrYtZ {
    padding: 35px 0 0 15px;
  }

  .ManageSubCategoryList-widthInner-I0M3m {
    width: 100%;
    margin: 0px auto 0 auto;
    border-radius: 0;
  }

  .ManageSubCategoryList-responsiveNoPadding-ZoYtr {
    padding: 0px !important;
  }

  .ManageSubCategoryList-contentOne-fghvg {
    position: relative !important;
    text-align: left !important;
    width: auto !important;
    padding: 0px 15px !important;
  }

  .ManageSubCategoryList-aboutContainer-vscpD {
    padding: 30px 0 30px !important;
  }

  .ManageSubCategoryList-noPosition-HeGw8 {
    left: 0 !important;
    right: 0 !important;
    top: 0 !important;
  }

  .ManageSubCategoryList-mobimleImg-Vh6iQ {
    display: none !important;
  }

  .ManageSubCategoryList-totalCss-sdUfL {
    width: 100% !important;
  }

  .ManageSubCategoryList-imgWidth-PK9UZ {
    padding: 18px !important;
  }

  .ManageSubCategoryList-searchInput-kMdxv,
  .ManageSubCategoryList-assignProviderSearchInput-M_si_ {
    max-width: 100% !important;
  }

  .ManageSubCategoryList-exportText-Wjckj {
    display: inline-block;
  }

  .ManageSubCategoryList-gridSystem-sFezS {
    grid-template-columns: auto !important;
  }

  .ManageSubCategoryList-padding-u7XM5 {
    padding: 52px 0 0 0 !important;
  }

  .ManageSubCategoryList-heading-O1EQw {
    padding: 30px 0 24px !important;
  }

  .ManageSubCategoryList-singleCard-nyzag {
    width: 100% !important;
  }

  .ManageSubCategoryList-displayGrid-Xm5Tt {
    grid-template-columns: 100% !important;
    grid-gap: 12px;
  }

  .ManageSubCategoryList-boxInner-Ye4Q0 {
    padding: 35px 0 !important;
  }

  .ManageSubCategoryList-navigationLink-AVMCr a:hover,
  .ManageSubCategoryList-navigationLink-AVMCr a:focus,
  .ManageSubCategoryList-navigationLink-AVMCr a:active {
    border-bottom: 2px solid transparent;
  }
}

@media (max-width: 480px) and (min-width: 320px) {
  .ManageSubCategoryList-whiteDropdown-Kk4wc select {
    width: 120px !important;
  }
}

.ManageSubCategoryList-manageSubCategoryCardContainer-RrOWy {
    display: grid;
    grid-template-columns: repeat(3, calc(33.33333% - 16px));
    gap: 24px;
    margin-top: 32px;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
}

.ManageSubCategoryList-manageSubCategoryCard-hKzhP {
    background: var(--background-quaternary);
    -webkit-box-shadow: 0px 2px 14px 0px var(--shadow-2);
            box-shadow: 0px 2px 14px 0px var(--shadow-2);
    border-radius: 6px 0 6px 0;
    padding: 12px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    text-align: start;
}

.ManageSubCategoryList-manageSubServiceCardNoResultContainer-cbOGc {
    margin-top: 32px;
    min-height: 492px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 12px;
    grid-gap: 12px;
}

.ManageSubCategoryList-manageSubServiceCardNoResultImgBox-MR0Ka {
    width: 188px;
    height: 178px;
    position: relative;
}

.ManageSubCategoryList-manageSubServiceCardNoResultImg-iJzTj {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: contain;
       object-fit: contain;
    -o-object-position: center;
       object-position: center;
}

.ManageSubCategoryList-manageSubServiceCardNoResultText-FD875 {
    font-size: 16px;
    font-weight: 600;
    line-height: 26px;
    color: var(--secondary-foreground);
    text-align: center;
}

.ManageSubCategoryList-manageSubServiceSaveBtnBox-O0SPb {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: end;
        -ms-flex-pack: end;
            justify-content: flex-end;
    margin-top: 24px;
    padding-top: 24px;
    border-top: 1px solid var(--primary-border);
}

@media (max-width: 1299px) and (min-width: 768px) {
    .ManageSubCategoryList-manageSubCategoryCardContainer-RrOWy {
        grid-template-columns: repeat(2, calc(50% - 12px));
    }
}

@media (max-width: 767px) {
    .ManageSubCategoryList-manageSubCategoryCardContainer-RrOWy {
        grid-template-columns: 100%;
    }
}

@media (max-width: 575px) {
    .ManageSubCategoryList-manageServiceCardNoResultContainer-EF7fc {
        min-height: 350px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Common.css","webpack://./src/components/responsive-common.css","webpack://./src/components/ManageSubCategory/ManageSubCategoryList/ManageSubCategoryList.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA,iBAAiB;;AACjB;IACI,kCAAkC;IAClC,eAAe;AACnB;;AAEA,eAAe;;AAEf,WAAW;;AAEX;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,2CAA2C;IAC3C,eAAe;IACf,oCAAoC;AACxC;;AAEA;;;IAGI,kDAAkD;AACtD;;AAEA,WAAW;;AAEX,cAAc;;AACd;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;;;IAGI,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,cAAc;;AAEd;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;;IAGI,qBAAqB;IACrB,kCAAkC;IAClC,4CAA4C;IAC5C,oBAAoB;IACpB,mBAAmB;IACnB,0BAA0B;IAC1B,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,mCAAmC;;AAEvC;;AAEA;IACI,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,2BAA2B;IAC3B,eAAe;IACf,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA,+DAA+D;;AAC/D;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,mBAAe;QAAf,eAAe;IACf,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,gDAAgD;IAChD,iCAAiC;IACjC,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB;;AAEA,6DAA6D;;AAC7D;;IAEI,gDAAgD;IAChD,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;;AAEJ;;AC1OA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;;AAGF;;AAEA;EACE;IACE,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE;IACE,2CAA2C;EAC7C;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;IAC7B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;;EAGA;IACE,sBAAsB;EACxB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;IACxB,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,mCAA2B;IAA3B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sCAAsC;IACtC,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,oCAAoC;EACtC;AACF;;AAGA;EACE;IACE,uBAAuB;EACzB;AACF;;ACzPA;IACI,aAAa;IACb,wDAA+D;IAC/D,SAAS;IACT,gBAAgB;IAChB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,wCAAwC;IACxC,oDAA4C;YAA5C,4CAA4C;IAC5C,0BAA0B;IAC1B,aAAa;IACb,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;IACnB,0BAAuB;OAAvB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,qBAAyB;QAAzB,kBAAyB;YAAzB,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,2CAA2C;AAC/C;;AAEA;IACI;QACI,kDAAyD;IAC7D;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".containerWith {\n    width: 100%;\n    max-width: 1260px !important;\n    margin: 0 auto;\n}\n\n.container {\n    max-width: 100%;\n}\n\n/* Text - Start */\n.subText {\n    color: var(--secondary-foreground);\n    font-size: 14px;\n}\n\n/* Text - End */\n\n/* Header */\n\n.navigationLink a {\n    padding-right: 20px !important;\n    padding-left: 20px !important;\n    color: var(--primary-foreground) !important;\n    font-size: 18px;\n    border-bottom: 2px solid transparent;\n}\n\n.navigationLink a:hover,\n.navigationLink a:focus,\n.navigationLink a:active {\n    border-bottom: 2px solid var(--primary-foreground);\n}\n\n/* Header */\n\n/* commonCss */\n.noPadding {\n    padding: 0;\n}\n\n.heading {\n    padding: 30px 0px 24px 0px;\n    font-weight: 700;\n    font-size: 24px;\n    color: var(--primary-foreground);\n}\n\n.widthInner {\n    margin: 0px auto 0px auto;\n    border-radius: 4px;\n    padding: 0px;\n    margin: 0px 15px 30px;\n}\n\n.noMargin {\n    margin: 0;\n}\n\n.formControlInputTable {\n    border: none;\n    width: 100px;\n    height: auto;\n}\n\n.backBtn {\n    margin-left: 15px;\n    display: inline-block;\n}\n\n.backBtn:active,\n.backBtn:hover,\n.backBtn:focus {\n    color: var(--primary-bg);\n    text-decoration: none !important;\n}\n\n.textAlignRight {\n    text-align: right;\n}\n\n.displayInlineBlock {\n    display: inline-block;\n}\n\n.displayBlock {\n    display: block;\n}\n\n.countryCode {\n    width: 15%;\n    vertical-align: top;\n}\n\n.vtrMiddle {\n    vertical-align: middle;\n}\n\n/* commonCss */\n\n.editIcon {\n    width: 100%;\n    width: 15px;\n    vertical-align: middle;\n    margin-right: 3px;\n}\n\n.iconBtn,\n.iconBtn:hover,\n.iconBtn:focus {\n    padding: 0 !important;\n    background: transparent !important;\n    color: var(--danger-action-color) !important;\n    border: 0 !important;\n    white-space: nowrap;\n    font-size: 16px !important;\n    text-decoration: unset !important;\n    cursor: pointer;\n}\n\n.profileImg {\n    width: 100%;\n    height: auto;\n    margin-bottom: 18px;\n}\n\n.profileImgSection {\n    width: 100%;\n    margin: 0 auto;\n    padding: 30px;\n    border-radius: 12px;\n    border: 1px solid var(--primary-border);\n    background: var(--primary-input-bg);\n\n}\n\n.profileImgWidth {\n    margin: 0;\n    max-width: 100% !important;\n}\n\n.searchInput {\n    width: 100%;\n    max-width: 320px;\n}\n\n.backgroundImg {\n    padding-top: 42%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    margin-bottom: 18px;\n    border-radius: 4px;\n    background-color: transparent;\n    background-position: center;\n    margin-top: 6px;\n    border: 1px dashed var(--primary-border);\n    border-radius: 12px;\n}\n\n/*******************Export CSV section start ******************/\n.exportDisplay {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    align-items: center;\n    margin-bottom: 18px;\n    gap: 18px;\n    grid-gap: 18px;\n}\n\n.exportTextSection {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.exportText {\n    display: inline-block;\n    padding-right: 5px;\n}\n\n.exportTextContainer {\n    display: flex;\n    align-items: center;\n    color: var(--primary-link-foreground) !important;\n    text-decoration: unset !important;\n    border-bottom: 1px solid var(--primary-link-foreground);\n}\n\n.vtrTextBottom {\n    vertical-align: text-bottom;\n}\n\n.exportImg {\n    width: 100%;\n    max-width: 14px;\n    height: 14px;\n    object-fit: contain;\n}\n\n/*******************Export CSV section End ******************/\n.noLink,\n.noLink:hover {\n    color: var(--primary-link-foreground) !important;\n    cursor: pointer;\n}\n\n.singleCard {\n    width: 500px;\n    margin: 0 auto;\n}\n\n.defaultIcon {\n    background-size: 50px;\n}\n\n.assignProviderSearchInput {\n    width: 100%;\n    max-width: 324px;\n}\n\n.searchGroupContainer {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-grow: 1;\n}\n\n@media (max-width: 767px) {\n    .searchGroupContainer {\n        width: 100%;\n    }\n\n}","@media (max-width: 1199px) and (min-width: 1024px) {\n  .widthInner {\n    width: 100%;\n    border-radius: 0;\n    margin: 0 auto;\n  }\n\n  .aboutGrid img {\n    position: relative;\n    top: -25px !important;\n  }\n\n  .responsiveView {\n    width: 100% !important;\n    max-width: 175px !important;\n  }\n\n  .positionFive {\n    top: 28% !important;\n  }\n\n  .positionTwo {\n    top: 28% !important;\n  }\n\n  .responsiveContentOne {\n    top: -50px !important;\n  }\n\n  .positionFour {\n    top: -50px !important;\n  }\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n\n}\n\n@media (max-width: 1024px) {\n  .navbar-expand-lg .navbar-toggler {\n    display: block !important;\n    position: absolute;\n    top: 23px;\n    right: 20px;\n  }\n\n  .profileImgSection {\n    padding: 18px;\n  }\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n\n  .navigationLink a {\n    color: var(--primary-foreground) !important;\n  }\n\n  .widthInner {\n    width: 100%;\n    border-radius: 0;\n    margin: 0 auto;\n  }\n\n  .responsiveContentOne {\n    width: 300px !important;\n    position: absolute !important;\n    top: -42px !important;\n    left: -5% !important;\n  }\n\n  .positionTwo {\n    top: 24% !important;\n    left: -5% !important;\n  }\n\n  .positionThree {\n    top: 70% !important;\n    left: -5% !important;\n  }\n\n  .positionFour {\n    top: -42px !important;\n    right: -5% !important;\n  }\n\n  .positionFive {\n    top: 20% !important;\n    right: -5% !important;\n  }\n\n  .positionSix {\n    top: 70% !important;\n    right: -5% !important;\n  }\n\n  .responsiveView {\n    width: 100% !important;\n    max-width: 115px !important;\n  }\n\n  .aboutGrid img {\n    top: -1px !important;\n  }\n\n  .contentOne h1 {\n    font-size: 16px !important;\n  }\n\n  .contentOne p {\n    font-size: 12px !important;\n  }\n\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n  .padding {\n    padding: 0px 0 0 60px !important;\n  }\n\n  .singleCard {\n    width: 100% !important;\n  }\n\n  .navigationLink a:hover,\n  .navigationLink a:focus,\n  .navigationLink a:active {\n    border-bottom: 2px solid transparent;\n  }\n}\n\n@media screen and (max-width: 823px) {\n  .navbar-collapse.show {\n    right: 0% !important;\n    top: 0 !important;\n  }\n\n  .navbar-collapse {\n    position: fixed !important;\n    height: 100vh !important;\n    width: 100% !important;\n    background: #fff !important;\n    right: -100% !important;\n    transition: 0.5s !important;\n  }\n}\n\n@media (max-width: 767px) {\n  .content {\n    float: none;\n  }\n\n  .mr-auto.navbar-nav {\n    padding-bottom: 80px !important;\n  }\n\n  .navigationLink a {\n    color: var(--primary-foreground) !important;\n  }\n\n  .footer {\n    padding: 35px 0 0 15px;\n  }\n\n  .widthInner {\n    width: 100%;\n    margin: 0px auto 0 auto;\n    border-radius: 0;\n  }\n\n  .responsiveNoPadding {\n    padding: 0px !important;\n  }\n\n  .contentOne {\n    position: relative !important;\n    text-align: left !important;\n    width: auto !important;\n    padding: 0px 15px !important;\n  }\n\n  .aboutContainer {\n    padding: 30px 0 30px !important;\n  }\n\n  .noPosition {\n    left: 0 !important;\n    right: 0 !important;\n    top: 0 !important;\n  }\n\n  .mobimleImg {\n    display: none !important;\n  }\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n  .imgWidth {\n    padding: 18px !important;\n  }\n\n  .searchInput,\n  .assignProviderSearchInput {\n    max-width: 100% !important;\n  }\n\n  .exportText {\n    display: inline-block;\n  }\n\n  .gridSystem {\n    grid-template-columns: auto !important;\n  }\n\n  .padding {\n    padding: 52px 0 0 0 !important;\n  }\n\n  .heading {\n    padding: 30px 0 24px !important;\n  }\n\n  .singleCard {\n    width: 100% !important;\n  }\n\n  .displayGrid {\n    grid-template-columns: 100% !important;\n    grid-gap: 12px;\n  }\n\n  .boxInner {\n    padding: 35px 0 !important;\n  }\n\n  .navigationLink a:hover,\n  .navigationLink a:focus,\n  .navigationLink a:active {\n    border-bottom: 2px solid transparent;\n  }\n}\n\n\n@media (max-width: 480px) and (min-width: 320px) {\n  .whiteDropdown select {\n    width: 120px !important;\n  }\n}","@import '../../../components/Common.css';\n@import '../../../components/responsive-common.css';\n\n.manageSubCategoryCardContainer {\n    display: grid;\n    grid-template-columns: repeat(3, calc((100% - (24px * 2)) / 3));\n    gap: 24px;\n    margin-top: 32px;\n    align-items: flex-start;\n}\n\n.manageSubCategoryCard {\n    background: var(--background-quaternary);\n    box-shadow: 0px 2px 14px 0px var(--shadow-2);\n    border-radius: 6px 0 6px 0;\n    padding: 12px;\n    display: flex;\n    flex-direction: column;\n    text-align: start;\n}\n\n.manageSubServiceCardNoResultContainer {\n    margin-top: 32px;\n    min-height: 492px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    gap: 12px;\n    grid-gap: 12px;\n}\n\n.manageSubServiceCardNoResultImgBox {\n    width: 188px;\n    height: 178px;\n    position: relative;\n}\n\n.manageSubServiceCardNoResultImg {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    object-position: center;\n}\n\n.manageSubServiceCardNoResultText {\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 26px;\n    color: var(--secondary-foreground);\n    text-align: center;\n}\n\n.manageSubServiceSaveBtnBox {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    margin-top: 24px;\n    padding-top: 24px;\n    border-top: 1px solid var(--primary-border);\n}\n\n@media (max-width: 1299px) and (min-width: 768px) {\n    .manageSubCategoryCardContainer {\n        grid-template-columns: repeat(2, calc((100% - 24px) / 2));\n    }\n}\n\n@media (max-width: 767px) {\n    .manageSubCategoryCardContainer {\n        grid-template-columns: 100%;\n    }\n}\n\n@media (max-width: 575px) {\n    .manageServiceCardNoResultContainer {\n        min-height: 350px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerWith": `ManageSubCategoryList-containerWith-SA77u`,
	"container": `ManageSubCategoryList-container-bfEGc`,
	"subText": `ManageSubCategoryList-subText-pheI9`,
	"navigationLink": `ManageSubCategoryList-navigationLink-AVMCr`,
	"noPadding": `ManageSubCategoryList-noPadding-UXv_h`,
	"heading": `ManageSubCategoryList-heading-O1EQw`,
	"widthInner": `ManageSubCategoryList-widthInner-I0M3m`,
	"noMargin": `ManageSubCategoryList-noMargin-Wn10t`,
	"formControlInputTable": `ManageSubCategoryList-formControlInputTable-RpWaf`,
	"backBtn": `ManageSubCategoryList-backBtn-Hifbx`,
	"textAlignRight": `ManageSubCategoryList-textAlignRight-V6Cnq`,
	"displayInlineBlock": `ManageSubCategoryList-displayInlineBlock-EKwFe`,
	"displayBlock": `ManageSubCategoryList-displayBlock-dZD2p`,
	"countryCode": `ManageSubCategoryList-countryCode-_tV9V`,
	"vtrMiddle": `ManageSubCategoryList-vtrMiddle-ioFvf`,
	"editIcon": `ManageSubCategoryList-editIcon-P8XE5`,
	"iconBtn": `ManageSubCategoryList-iconBtn-xuurk`,
	"profileImg": `ManageSubCategoryList-profileImg-HwvQt`,
	"profileImgSection": `ManageSubCategoryList-profileImgSection-YEhvr`,
	"profileImgWidth": `ManageSubCategoryList-profileImgWidth-T5omF`,
	"searchInput": `ManageSubCategoryList-searchInput-kMdxv`,
	"backgroundImg": `ManageSubCategoryList-backgroundImg-T5VUQ`,
	"exportDisplay": `ManageSubCategoryList-exportDisplay-feYyz`,
	"exportTextSection": `ManageSubCategoryList-exportTextSection-waAFd`,
	"exportText": `ManageSubCategoryList-exportText-Wjckj`,
	"exportTextContainer": `ManageSubCategoryList-exportTextContainer-FCQIH`,
	"vtrTextBottom": `ManageSubCategoryList-vtrTextBottom-FOArq`,
	"exportImg": `ManageSubCategoryList-exportImg-QCQQD`,
	"noLink": `ManageSubCategoryList-noLink-JHWbe`,
	"singleCard": `ManageSubCategoryList-singleCard-nyzag`,
	"defaultIcon": `ManageSubCategoryList-defaultIcon-NWhJV`,
	"assignProviderSearchInput": `ManageSubCategoryList-assignProviderSearchInput-M_si_`,
	"searchGroupContainer": `ManageSubCategoryList-searchGroupContainer-tMmkG`,
	"aboutGrid": `ManageSubCategoryList-aboutGrid-M5Ne1`,
	"responsiveView": `ManageSubCategoryList-responsiveView-ePWd3`,
	"positionFive": `ManageSubCategoryList-positionFive-ZNxxw`,
	"positionTwo": `ManageSubCategoryList-positionTwo-EBbuN`,
	"responsiveContentOne": `ManageSubCategoryList-responsiveContentOne-Imm_s`,
	"positionFour": `ManageSubCategoryList-positionFour-GP2oN`,
	"totalCss": `ManageSubCategoryList-totalCss-sdUfL`,
	"navbar-expand-lg": `ManageSubCategoryList-navbar-expand-lg-L7ip4`,
	"navbar-toggler": `ManageSubCategoryList-navbar-toggler-D0PS4`,
	"positionThree": `ManageSubCategoryList-positionThree-d8_uC`,
	"positionSix": `ManageSubCategoryList-positionSix-Zmcb_`,
	"contentOne": `ManageSubCategoryList-contentOne-fghvg`,
	"padding": `ManageSubCategoryList-padding-u7XM5`,
	"navbar-collapse": `ManageSubCategoryList-navbar-collapse-JM8hf`,
	"show": `ManageSubCategoryList-show-EW43C`,
	"content": `ManageSubCategoryList-content-foQsv`,
	"mr-auto": `ManageSubCategoryList-mr-auto-cRt7f`,
	"navbar-nav": `ManageSubCategoryList-navbar-nav-dnAe9`,
	"footer": `ManageSubCategoryList-footer-ZrYtZ`,
	"responsiveNoPadding": `ManageSubCategoryList-responsiveNoPadding-ZoYtr`,
	"aboutContainer": `ManageSubCategoryList-aboutContainer-vscpD`,
	"noPosition": `ManageSubCategoryList-noPosition-HeGw8`,
	"mobimleImg": `ManageSubCategoryList-mobimleImg-Vh6iQ`,
	"imgWidth": `ManageSubCategoryList-imgWidth-PK9UZ`,
	"gridSystem": `ManageSubCategoryList-gridSystem-sFezS`,
	"displayGrid": `ManageSubCategoryList-displayGrid-Xm5Tt`,
	"boxInner": `ManageSubCategoryList-boxInner-Ye4Q0`,
	"whiteDropdown": `ManageSubCategoryList-whiteDropdown-Kk4wc`,
	"manageSubCategoryCardContainer": `ManageSubCategoryList-manageSubCategoryCardContainer-RrOWy`,
	"manageSubCategoryCard": `ManageSubCategoryList-manageSubCategoryCard-hKzhP`,
	"manageSubServiceCardNoResultContainer": `ManageSubCategoryList-manageSubServiceCardNoResultContainer-cbOGc`,
	"manageSubServiceCardNoResultImgBox": `ManageSubCategoryList-manageSubServiceCardNoResultImgBox-MR0Ka`,
	"manageSubServiceCardNoResultImg": `ManageSubCategoryList-manageSubServiceCardNoResultImg-iJzTj`,
	"manageSubServiceCardNoResultText": `ManageSubCategoryList-manageSubServiceCardNoResultText-FD875`,
	"manageSubServiceSaveBtnBox": `ManageSubCategoryList-manageSubServiceSaveBtnBox-O0SPb`,
	"manageServiceCardNoResultContainer": `ManageSubCategoryList-manageServiceCardNoResultContainer-EF7fc`
};
module.exports = ___CSS_LOADER_EXPORT___;
